/** @format */

import Theme from "./Theme";
import ThemeComponents from "./ThemeComponents";
import ThemeContent from "./ThemeContent";
import ThemeForms from "./ThemeForms";

const themeRoutes = [
  {
    element: <Theme />,
    children: [
      { path: "content", element: <ThemeContent /> },
      { path: "components", element: <ThemeComponents /> },
      { path: "forms", element: <ThemeForms /> },
    ],
  },
];

export default themeRoutes;
